import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useCrmNote, CrmNote } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<CrmNote>
      useData={useCrmNote}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

